import PitchResult from '../enums/PitchResult.js';

const classifyAsStrikeOut = [PitchResult.StrikeoutLooking.key, PitchResult.StrikeoutSwinging.key];

const classifiesAsStrikeOut = function(taggedPitchResultKey){
    if (typeof taggedPitchResultKey !== 'string'){
        return false;
    }

    return classifyAsStrikeOut.indexOf(taggedPitchResultKey) > -1;
};

export default classifiesAsStrikeOut;